import { atom } from "recoil";

export const enlargeState = atom({
  key: "enlargeState",
  default: { visible: false, widget: "" },
});
